const Card = ({ heading, content, image }) => {

  return (
    <div className="d-flex gap-2">
      <div>
        <div className="fw-semibold">
          {heading}
        </div>
        <ul>
          <li>
            {content}
          </li>
        </ul>
      </div>
      <div>
        <img src={image || ''} alt="" width={185} height={111} />
      </div>
    </div>
  )

}

export default Card